<!-- <div  id="svgarea" class="svg-area" [style.height.px]="widgetheight">
</div> -->
<div  id="{{id}}" class="svg-area" [style.height.px]="widgetheight">
</div>

